// represents the following features that can be added to particular lens:
// Bevel, Edge, Tint Color, TintType
export const LensFeatureType = {
  BEVEL: 'BEVEL',
  EDGE: 'EDGE',
  TINT_TYPE: 'TINT_TYPE',
  TINT_COLOR: 'TINT_COLOR'
}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspace/ng-labportal-sandbox-build/src/app/shared/data/lens-feature-type.ts